/**
 * Testimonials Slider
 * File: assets/custom-testimonials.js
 */
(function () {
  'use strict';

  const slider = document.getElementById('tm-slider');
  const dotsContainer = document.getElementById('tm-dots');
  const prevBtn = document.getElementById('tm-prev');
  const nextBtn = document.getElementById('tm-next');

  if (!slider) return;

  const cards = Array.from(slider.querySelectorAll('.custom-testimonials__card'));
  if (cards.length === 0) return;

  let currentIndex = 0;
  let autoplayTimer = null;
  const visibleCount = () => window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 3;

  // Build dots
  function buildDots() {
    dotsContainer.innerHTML = '';
    const totalDots = Math.ceil(cards.length / visibleCount());
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('button');
      dot.className = 'tm-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Go to review ${i + 1}`);
      dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      dot.addEventListener('click', () => goTo(i * visibleCount()));
      dotsContainer.appendChild(dot);
    }
  }

  function updateDots() {
    const dots = dotsContainer.querySelectorAll('.tm-dot');
    const activeIndex = Math.floor(currentIndex / visibleCount());
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === activeIndex);
      dot.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
    });
  }

  function goTo(index) {
    const maxIndex = cards.length - visibleCount();
    currentIndex = Math.max(0, Math.min(index, maxIndex));
    const cardWidth = cards[0].offsetWidth + 16; // gap = 16px
    slider.scrollTo({ left: currentIndex * cardWidth, behavior: 'smooth' });
    updateDots();
  }

  function goNext() {
    const maxIndex = cards.length - visibleCount();
    goTo(currentIndex >= maxIndex ? 0 : currentIndex + 1);
  }

  function goPrev() {
    const maxIndex = cards.length - visibleCount();
    goTo(currentIndex <= 0 ? maxIndex : currentIndex - 1);
  }

  // Autoplay
  function startAutoplay() {
    autoplayTimer = setInterval(goNext, 4500);
  }

  function stopAutoplay() {
    clearInterval(autoplayTimer);
  }

  prevBtn?.addEventListener('click', () => { stopAutoplay(); goPrev(); startAutoplay(); });
  nextBtn?.addEventListener('click', () => { stopAutoplay(); goNext(); startAutoplay(); });

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);

  // Touch swipe
  let touchStartX = 0;
  slider.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
  slider.addEventListener('touchend', (e) => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? goNext() : goPrev();
  }, { passive: true });

  // Rebuild on resize
  window.addEventListener('resize', () => {
    buildDots();
    goTo(0);
  }, { passive: true });

  // Init
  buildDots();
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    startAutoplay();
  }

})();